export const iconList: any[] = [
    'orgApp-night-duty1',
    'orgApp-night-duty2',
    'orgApp-night-duty3',
    'orgApp-night-duty4',
    'orgApp-night-duty5',
    'orgApp-night-duty6',
    'orgApp-night-duty7',
    'orgApp-night-duty8',
    'orgApp-night-duty9',
    'orgApp-night-duty10',
    'orgApp-night-duty11',
    'orgApp-night-duty12',
    'orgApp-day-duty1',
    'orgApp-day-duty2',
    'orgApp-day-duty3',
    'orgApp-day-duty4',
    'orgApp-day-duty5',
    'orgApp-day-duty6',
    'orgApp-day-duty7',
    'orgApp-day-duty8',
    'orgApp-day-duty9',
    'orgApp-day-duty10',
    'orgApp-meeting1',
    'orgApp-meeting2',
    'orgApp-meeting3',
    'orgApp-school-day',
    'orgApp-bdy1',
    'orgApp-bdy2',
    'orgApp-bdy4',
    'orgApp-game1',
    'orgApp-calendar1',
    'orgApp-calendar2',
    'orgApp-calendar3',
    'casual_leave_default',
    'casual-leave-2',
    'orgApp-holiday-icon-3',
    'sick-leave-1',
    'sick_leave_default',
    'orgApp-holiday-icon',
    'orgApp-holiday-icon-2',
    'late-duty-1',
    'late-duty-2',
    'late-duty-3',
    'late-duty-4',
    'duty-in-charge-1',
    'duty-in-charge-2',
    'zeit',
    'Ferien-inkl',
    'krank-one-day',
    'krank-6-14-Tag',
    'krank-ab-15-Tag',
    'krank-Schwanger-bis-5-Tag',
    'krank-Schwanger-6-14-Tag',
    'krank-Schwanger-ab-15-Tag',
    'Kastanien-emoji-smile',
    'Kastanien-emoji-sad',
    'Kastanien-emoji-smile2',
    'Kastanien-emoji-smile3',
    'Kastanien-emoji-smile4',
    'Kastanien-marriage',
    'Kastanien-marriage1',
    'Kastanien-marriage2',
    'Kastanien-marriage3',
    'Kastanien-marriage4',
    'BU-bis-5',
    'Kastanien-medical',
    'Kastanien-medical1',
    'Kastanien-medical2',
    'Kastanien-medical3',
    'Kastanien-medical4',
    'Kastanien-childcare',
    'Kastanien-childcare1',
    'Kastanien-childcare2',
    'Kastanien-childcare3',
    'Kastanien-childcare4',
    'Kastanien-config',
    'Kastanien-config1',
    'Kastanien-config2',
    'Kastanien-relocation',
    'Kastanien-relocation1',
    'Kastanien-relocation2',
    'Kastanien-school',
    'Kastanien-school1',
    'Kastanien-school2',
    'Kastanien-1',
    'Kastanien-11',
    'Kastanien-111',
    'Kastanien-2',
    'Kastanien-21',
    'Kastanien-211',
    'Kastanien-3',
    'Kastanien-31',
    'Kastanien-311',
    'Kastanien-4',
    'Kastanien-41',
    'Kastanien-411',
    'Kastanien-5',
    'Kastanien-51',
    'Kastanien-511',
    'Kastanien-death',
    'Kastanien-death1',
    'Kastanien-death2',
    'Kastanien-death3',
    "Legende-Frühdienst",
    "Legende-Nachmittagsdienst",
    "Legende-geteilter-Dienst",
    "Legende-Lernbegleitung-Lachen",
    "Legende-Einsatzplanung-Lachen",
    "Legende-PIL-Lachen",
     "Legende-Büro-Lachen",
    "Legende-Büro-Siebnen",
    "Legende-Tagesverantwortung",
    "Legende-QM",
    "Legende-Schule-FaGe",
    "Legende-Krankheit",
    "Legende-Schule-HF",
    "Legende-bezahlte-Absenz",
    "Legende-Leitungssitzung",
    "Legende-Teamsitzung",
    "Legende-kurzer-Spätdienst",
    "Legende-Abenddienst",
    "Legende-Freiwunsch-GT",
    "Schule-Kevin-1",
    "Schule-Kevin-2",
    "Ferien-01",
    "Ferien-02",
    "PIL-BZGS",
    "Legende-Probezeitgespräch",
    "Legende-welcome",
    "Legende-pattern-1",
    "Legende-pattern-2"
  ];
  
export const colorPalette: string[] = [
  // Bright / Neon / Vivid colors
  '#00FF00', // Neon Green (PIL)
  '#00BCD4', // Bright Cyan (FD)
  '#009688', // Teal (GD)
  '#8BC34A', // Lime (ND)
  '#FFC107', // Amber (TV)
  '#F44336', // Vivid Red (Q)
  '#3F51B5', // Medium Indigo (LS)
  '#9C27B0', // Purple (TS)
  '#2196F3', // Blue (AD)
  '#FF69B4', // Hot Pink

  // Medium colors (fill range between bright and pastel)
  '#4CAF50', // Medium Green
  '#FF9800', // Medium Orange
  '#03A9F4', // Sky Blue
  '#E91E63', // Pink

  // Grays / Neutrals
  '#000000', // Black (K)
  '#607D8B', // Blue Gray (SD)
  '#757575', // Medium Gray (S)
  '#BDBDBD', // Light Gray (PRT)
  '#E0E0E0', // Very Light Gray (BA)

  // Light shadow / pastel tones
  '#f8f9fa', '#e9ecef', '#dee2e6', '#ced4da',  // cool light grays
  '#dfe7fd', '#e3f2fd',                       // pale blues
  '#fce4ec', '#f3e5f5',                       // pale pinks & lavenders
  '#fff3e0', '#ffe0b2', '#fbe9e7',            // pale oranges & peaches
  '#f1f8e9', '#f0f4c3', '#f9fbe7',            // pale greens & yellows
  '#ede7f6', '#e1f5fe',                       // additional pale blues & lavenders
];